import { useDirectoryInvalidation } from '@/modules/file-manager/hooks/use-directory-invalidation'

/**
 * Mounts the one consumer that turns channel events into re-reads. Renders
 * nothing.
 *
 * A component and not a call inside the shell, because the hook has to sit
 * under `DirectoryFeedProvider` to hear anything and the shell is the element
 * that provides it: a component cannot consume a context it renders itself.
 * One line of JSX instead of splitting the shell in two.
 */
export function DirectoryInvalidation() {
	useDirectoryInvalidation()
	return null
}
